import { render, staticRenderFns } from "./quantile.vue?vue&type=template&id=dc7faf3c&scoped=true&lang=pug&"
import script from "./quantile.vue?vue&type=script&lang=js&"
export * from "./quantile.vue?vue&type=script&lang=js&"
import style0 from "./quantile.vue?vue&type=style&index=0&id=dc7faf3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7faf3c",
  null
  
)

export default component.exports